import * as React from 'react'
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { MdTimer } from 'react-icons/md'
// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';
import { BsPinMap } from 'react-icons/bs';
import { ILocation } from './types'

export const ParameterPanel = (props: ILocation) => {

    const [latitude, setLatitude, setLatitudeResult] = useSetObjectValue(props.id, props.resourceGroupId, "latitude", props.latitude);
    const onValueChanged = (e: any) => setLatitude(parseFloat(e.target.value));
    const [longitude, setLongitude, setLongitudeResult] = useSetObjectValue(props.id, props.resourceGroupId, "longitude", props.longitude);
    const onValueChangedLongitude = (e: any) => setLongitude(parseFloat(e.target.value));

    return (
        <>
            <FormControl
                label={<FormattedMessage id="Location.Latitude" defaultMessage="Latitude" />}
                caption={<FormattedMessage id="Location.LatitudeDescription" defaultMessage="Enter the locations latitude" />}
                error={setLatitudeResult.isError}
            >
                <Input
                    value={latitude}
                    onChange={onValueChanged}
                    startEnhancer={<BsPinMap />}
                    type='number'
                />
            </FormControl>

            <FormControl
                label={<FormattedMessage id="Location.Longitude" defaultMessage="Longitude" />}
                caption={<FormattedMessage id="Location.LongitudeDescription" defaultMessage="Enter the locations longitude" />}
                error={setLatitudeResult.isError}
            >
                <Input
                    value={longitude}
                    onChange={onValueChangedLongitude}
                    startEnhancer={<BsPinMap />}
                    type='number'
                />
            </FormControl>
        </>
    )
}
